'use strict';

let isDesktop = require('../utilities/clientSideUtil').isDesktop;

/**
 * To add smooth scrolling behavior to page anchor
 *
 * @param {Object} e - event
 * 
 */
var handleSmoothScroll = (e) => {
    e.preventDefault();
    let yOffset;

    if (isDesktop()) {
        yOffset = -($('.nav').outerHeight());
    } else {
        yOffset = 0;
    }

    const el = document.querySelector($(e?.target).attr('href'));
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
};

module.exports = {
    inPageNavigation: function () {
        $(document).on('click', 'a', function (e) {
            const scrollTarget = $(e?.target)?.attr('href');
            if (scrollTarget?.length > 1 && scrollTarget?.charAt(0) === '#') {
                handleSmoothScroll(e);
            }
        });
    }
};
